import { Directive, ElementRef, Input, OnChanges, OnInit, Optional, SimpleChanges } from '@angular/core';

import { DialogRef } from '../helpers';
import { getClosestDialog } from '../helpers/dialog-ref';
import { Dialog } from '../dialog.service';

/**
 * Button that will close the current dialog.
 */
@Directive({
	selector: `button[flx-dialog-close], button[flxDialogClose]`,
	exportAs: 'flxDialogClose',
	host: {
		'(click)': 'dialogRef.close(dialogResult)',
		'[attr.aria-label]': 'ariaLabel',
		type: 'button' // Prevents accidental form submits.
	}
})
export class DialogCloseDirective implements OnInit, OnChanges {
	@Input('aria-label') ariaLabel = 'Close dialog';

	/** Dialog close input. */
	@Input('flx-dialog-close') dialogResult: any;

	@Input('flxDialogClose') _fsDialogClose: any;

	constructor(@Optional() public dialogRef: DialogRef<any>, private _elementRef: ElementRef, private _dialog: Dialog) {}

	ngOnInit() {
		if (!this.dialogRef) {
			// When this directive is included in a dialog via TemplateRef (rather than being
			// in a Component), the DialogRef isn't available via injection because embedded
			// views cannot be given a custom injector. Instead, we look up the DialogRef by
			// ID. This must occur in `onInit`, as the ID binding for the dialog container won't
			// be resolved at constructor time.
			this.dialogRef = getClosestDialog(this._elementRef, this._dialog.openDialogs)!;
		}
	}

	ngOnChanges(changes: SimpleChanges) {
		const proxiedChange = changes["_fsDialogClose"] || changes["_fsDialogCloseResult"];

		if (proxiedChange) {
			this.dialogResult = proxiedChange.currentValue;
		}
	}
}
